/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  box-sizing: border-box;
  visibility: hidden;
  font-size: 1rem;
  position: absolute;
  z-index: 20;
  top: -999999px;
  left: -999999px;
  background: #FFFFFF;
  background: var(--davinci-color-background, #FFFFFF);
  color: #2C3133;
  color: var(--davinci-color-text-on-background, #2C3133);
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}
:host:before {
  background: #FFFFFF;
  background: var(--davinci-color-background, #FFFFFF);
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  content: "";
  position: absolute;
  transform: rotate(45deg);
  height: 12px;
  width: 12px;
}
:host .content {
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background, #FFFFFF);
  z-index: 21;
  position: relative;
  margin: 0px;
  padding: 0px;
  float: left;
}
:host .backdrop {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: none;
  z-index: 20;
}

:host([open]) {
  visibility: visible;
  top: initial;
  left: initial;
}
:host([open]) .backdrop {
  display: block;
}

:host([side=left]):before {
  right: -6px;
  top: 12px;
}

:host([side=right]):before {
  left: -6px;
  top: 12px;
}

:host([side=left][alt-direction]):before,
:host([side=right][alt-direction]):before {
  top: initial;
  bottom: 12px;
}

:host([side=top]):before {
  bottom: -6px;
  left: 12px;
}

:host([side=bottom]):before {
  top: -6px;
  left: 12px;
}

:host([side=top][alt-direction]):before,
:host([side=bottom][alt-direction]):before {
  left: initial;
  right: 12px;
}`;
export { style };
